import { DocumentoNegociableService } from './../../../services/documento-negociable/documento-negociable.service';
import { Component, OnInit,ViewChild } from '@angular/core';
import { MatTableDataSource, MatPaginator, MatSort,DateAdapter,MAT_DATE_LOCALE,MAT_DATE_FORMATS} from '@angular/material';
import { Observable } from 'rxjs/Rx';
import { startWith, map } from 'rxjs/operators';
import { FormControl,FormGroup} from '@angular/forms';
import { Router } from '@angular/router';
import { DatePipe } from "@angular/common";
import Swal from "sweetalert2";
import * as moment from 'moment';
import { FiltrosAdquirentePago} from '../../../models/FiltrosAdquirentePago';
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import { MessagesTitles, MessagesGeneral, MessagesDates } from '../../../models/messages';
import { CobranzasService } from '../../../services/cobranzas/cobranzas.service';
import { environment } from 'environments/environment';

export const MY_FORMATS = {
  parse: {
    dateInput: "DD-MM-YYYY"
  },
  display: {
    dateInput: "DD-MM-YYYY",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "DD-MM-YYYY",
    monthYearA11yLabel: "MMMM YYYY"
  }
};

@Component({
  selector: 'app-adquirente-pago',
  templateUrl: './adquirente-pago.component.html',
  styleUrls: ['./adquirente-pago.component.scss'],
  providers: [MessagesTitles,MessagesGeneral,MessagesDates,
    DatePipe,
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
  ]
})
export class AdquirentePagoComponent implements OnInit {
  Label_Proveedor=environment.LABEL_PROVEEDOR;
  Label_Proveedores=environment.LABEL_PROVEEDORES;
  Label_Adquirente=environment.LABEL_ADQUIRENTE;
  Label_Adquirentes=environment.LABEL_ADQUIRENTES;
  Label_id_soles=environment.ID_GUIA_SOLES;
  loading:boolean;
  abrirDetallePagos : boolean = false;
  abrirEditarAdquirentes : boolean = false;
  dtoAdquiPago : any = [];  
  idAdquirente :any;
  adquirentesArr:any;
  rucAdq = new FormControl();
  filteredAdquirente: Observable<any[]>;
  fechaD: Date = new Date();
  fechaH: Date = new Date();
  adquirente: any = [];
 

  DTOFiltrosAdqPago :FiltrosAdquirentePago = new FiltrosAdquirentePago();
  today = moment();
  dataFiltro : FormGroup;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;  
  @ViewChild(MatSort, {static: true}) sort: MatSort;
 
  pageSizeOptions = [15,20,30,50,100,200];
  filterValues = {
    Adquirente:'',
    Estado:'',
    Banco:'',
    Moneda:'',
    Tipo_Pago:'',
    Fecha_Inicio:'',
    Fecha_Fin:''
    }; 
  
  displayedColumns: string[] = ['checked','idCobranza','Fecha','RazonSocialAdquirente','Moneda','Deposito_Importe','Deposito_a_Aplicar','Cuenta','Banco','Tipo_Pago','CodigoDeposito','Estado'];
  dataSource =new MatTableDataSource( this.dtoAdquiPago);

  constructor( private cobranzasService:CobranzasService,private datePipe :DatePipe , private router:Router,private negociablesService:DocumentoNegociableService) {
    this.fechaD.setDate(this.fechaD.getDate()-60);
    this.ObtenerAdquirentesCombo();
    this.dataFiltro = new FormGroup({
      "Fecha_Inicio": new FormControl(''),
      "Fecha_Fin": new FormControl(''),
      "Banco":new FormControl(0),
      "Moneda":new FormControl(0),
      "Tipo_Pago":new FormControl(0)
    });  
   }

  ngOnInit() {
   this.filtradoAdquirentePago();

   this.rucAdq.valueChanges
    .subscribe(
      Adquirente => {
        this.filterValues.Adquirente = Adquirente;
        this.dataSource.filter = JSON.stringify(this.filterValues);
      }
    );
    this.dataFiltro.get('Banco').valueChanges.subscribe(
      Banco => {
        this.filterValues.Banco = Banco;
        this.dataSource.filter = JSON.stringify(this.filterValues);
      }
    );
    this.dataFiltro.get('Moneda').valueChanges.subscribe(
      Moneda => {
        this.filterValues.Moneda = Moneda;
        this.dataSource.filter = JSON.stringify(this.filterValues);
      }
    );
    this.dataFiltro.get('Fecha_Inicio').valueChanges.subscribe(
      Fecha_Inicio => {
        this.filterValues.Fecha_Inicio = (Fecha_Inicio === null ? "" : this.datePipe.transform(Fecha_Inicio, 'yyyy-MM-dd'));
        this.dataSource.filter = JSON.stringify(this.filterValues);
      }
    );

    this.dataFiltro.get('Fecha_Fin').valueChanges.subscribe(
      Fecha_Fin => {
        this.filterValues.Fecha_Fin = (Fecha_Fin === null ? "" : this.datePipe.transform(Fecha_Fin, 'yyyy-MM-dd'));
        this.dataSource.filter = JSON.stringify(this.filterValues);
      }
    );
    const elem=document.getElementById('element-button');
      elem.style.display='none';
  }

  createFilter(): (data: any, filter: string) => boolean {
    return function(data, filter): boolean {
      let searchTerms = JSON.parse(filter);
      return  data.RazonSocialAdquirente.toString().toLowerCase().indexOf(searchTerms.Adquirente) !== -1
      && data.Banco.toString().toUpperCase().indexOf(searchTerms.Banco) !== -1
      && data.Moneda.toString().toUpperCase().indexOf(searchTerms.Moneda) !== -1
      && data.Fecha >= (searchTerms.Fecha_Inicio == "" ? data.Fecha : searchTerms.Fecha_Inicio)
      && data.Fecha <= (searchTerms.Fecha_Fin == "" ? data.Fecha : searchTerms.Fecha_Fin)
    } 
  }

  tipoMoneda(event){
    if(event==''){
      this.DTOFiltrosAdqPago.Moneda=0;
      this.dataFiltro.controls["Moneda"].setValue('') 
    }else{
      this.DTOFiltrosAdqPago.Moneda = event;
      this.dataFiltro.controls["Moneda"].setValue(event) 
    } 
  }
  bancoIF(event){
    if(event==''){
      this.DTOFiltrosAdqPago.Banco=0;
      this.dataFiltro.controls["Banco"].setValue('')   
    }else{
      this.DTOFiltrosAdqPago.Banco = event;
      this.dataFiltro.controls["Banco"].setValue(event) 
     
    } 
  }
  
  filtradoAdquirentePago(){

    if (this.rucAdq.value == null){
      this.idAdquirente = "0";
      this.DTOFiltrosAdqPago.IdAdqui = "0";
    }
    this.loading = true;
    this.cobranzasService.FiltroListadoPagoAdquirente(this.DTOFiltrosAdqPago,this.datePipe.transform(this.fechaD,'yyyyMMdd'),this.datePipe.transform(this.fechaH,'yyyMMdd'))                                              
    .subscribe(
        res => {
          this.dtoAdquiPago = res;
          console.log('data',this.dtoAdquiPago)
      this.dataSource = new MatTableDataSource( this.dtoAdquiPago);
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;
      this.dataSource.filterPredicate = this.createFilter();
          this.loading = false;
        } , err =>{
            Swal.fire({
              title: "¡Algo salió mal!",
              text:  err.error['error'],
              type: "warning",
              allowOutsideClick: true,
              heightAuto: false
            });        
          this.loading = false;
        }
    )
    
  }
  

  obtenerRucRazSocialAdq(termino :string = ''){  
    if (termino != null && termino != ''){       
      let termino1 = termino.toLowerCase();                   
      for( let p of this.adquirentesArr){
          let raz = p.Razon_Social.toLocaleLowerCase();
        if (raz.indexOf(termino1)  >= 0){         
            this.idAdquirente = p.idEmpresa;
            this.DTOFiltrosAdqPago.IdAdqui = p.idEmpresa;
          }
      }
    }
  }
  

  

  ObtenerAdquirentesCombo() {
      this.adquirentesArr = JSON.parse(sessionStorage.getItem('lstAdqCbo'));
      this.filteredAdquirente = this.rucAdq.valueChanges
      .pipe(
        startWith(""),
        map(state =>
          state ? this._filterAdq(state) : this.adquirentesArr.slice()
        )
      ); 
  }

  private _filterAdq(value: string): any[] {
    const filterValue = value.toString().toLowerCase();
    return this.adquirentesArr.filter(
      state => state.Razon_Social.toLowerCase().includes(filterValue) === true
    );
  }


  
  obtenerIdAdq(termino :string){
    this.idAdquirente = termino;
    this.DTOFiltrosAdqPago.IdAdqui = termino;
  }



  abrirDetallePago(elemento:any){
    this.validarEmpresa(elemento.RucAdq);
    this.cobranzasService.datosDetallePago = elemento;
    
  }

  validarEmpresa(ruc: string) {

    this.negociablesService.validarEmpresaExistenteADQ(ruc).subscribe(
      data => {
        this.adquirente = data;
          if(this.adquirente.Estado == "X"){
            Swal.fire({
              title: '¡Alto!',
              text: 'Adquirente bloqueado, no puede continuar.',
              type: 'warning',
              allowOutsideClick: false,
              heightAuto: false
            });
          } else {
            this.abrirDetallePagos = true;
          }
        
      }
    );
  }


  abrirEditarAdquirente(idCobranzaPago:any,deposito:any){
    
    this.cobranzasService.idCobranzaPago = idCobranzaPago;
    this.cobranzasService.deposito = deposito;
    this.abrirEditarAdquirentes = true;
    
  }

  CerrarPopUpDetallePago(){
    this.abrirDetallePagos = false;
  }
  CerrarPopUpEditar(){
    this.abrirEditarAdquirentes = false;
  }

  Refresh(){
    this.ngOnInit();
  }


}
